import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import Logo from "../styles/images/logo.svg";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100); // wait for DOM render
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);
  // Using descriptive names as requested
  const navigationLinks = [
    { label: "About us", href: "/#about-us" },
    { label: "Our Mission", href: "/#mission" },
    { label: "Explore Rides", href: "/#rides" },
    { label: "Locations", href: "/#locations" },
    { label: "Contact", href: "/#contact" },
  ];

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`custom-navbar ${isScrolled ? "navbar-scrolled" : ""}`}
    >
      <Container>
        <Link to="/">
          <div className="logo-background">
            <img
              src={Logo}
              alt="ApniGaadi Logo"
              height="60"
              className="d-inline-block align-top"
            />
          </div>
        </Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            {navigationLinks.map((link, index) => (
              <HashLink
                key={index}
                to={link.href}
                className="nav-link nav-item-spacing"
              >
                {link.label}
              </HashLink>
            ))}
          </Nav>

          <Button className="download-button" href="#download">
            Download App
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
